import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import PetitionDetails from '../Petition/PetitionDetails';
import PetitionSuccess from '../Petition/PetitionSuccess';

const Opinion = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/opinion/start"
                            name="opinionStart"
                            exact
                            component={PetitionDetails}
                        />
                        <Route
                            path="/opinion"
                            name="opinionDetails"
                            exact
                            component={PetitionDetails}
                        />
                        <Route
                            path="/opinion/success"
                            name="opinionSuccess"
                            exact
                            component={PetitionSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Opinion;
